import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { AlertTriangle, CheckCircle } from "lucide-react";

const LeaveApprovalDialogSection = ({ ctx }) => {
  const {
    approvalRemarks,
    handleApproveLeave,
    leaveApprovalDialogOpen,
    leaveToApprove,
    revisedDaysCount,
    setApprovalRemarks,
    setLeaveApprovalDialogOpen,
    setRevisedDaysCount
  } = ctx;
  return (
    <>
      <Dialog open={leaveApprovalDialogOpen} onOpenChange={setLeaveApprovalDialogOpen}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle className="font-heading text-xl text-primary">APPROVE LEAVE REQUEST</DialogTitle>
          </DialogHeader>
          
          {leaveToApprove && (
            <div className="space-y-4 mt-4">
              {/* Leave Details Summary */}
              <div className="bg-slate-50 p-4 rounded-sm space-y-2">
                <div className="flex justify-between">
                  <span className="text-sm text-slate-600">Employee:</span>
                  <span className="font-semibold">{leaveToApprove.employee_name}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-sm text-slate-600">Leave Type:</span>
                  <span className="font-medium">{leaveToApprove.leave_type}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-sm text-slate-600">Period:</span>
                  <span className="font-mono text-sm">{leaveToApprove.start_date} to {leaveToApprove.end_date}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-sm text-slate-600">Requested Days:</span>
                  <span className="font-mono font-bold text-primary">{leaveToApprove.days_count}</span>
                </div>
                <div className="pt-2 border-t border-slate-200">
                  <span className="text-sm text-slate-600">Reason:</span>
                  <p className="text-sm mt-1">{leaveToApprove.reason}</p>
                </div>
              </div>

              {/* Revised Days Input */}
              <div className="p-4 bg-blue-50 border border-blue-200 rounded-sm">
                <label className="block text-xs font-medium text-blue-800 mb-2 uppercase tracking-widest">
                  Approved Days (Revise if needed)
                </label>
                <input
                  type="number"
                  min="0.5"
                  step="0.5"
                  max={leaveToApprove.days_count + 5}
                  value={revisedDaysCount}
                  onChange={(e) => setRevisedDaysCount(parseFloat(e.target.value) || 0)}
                  className="w-full px-4 py-2 border border-blue-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-blue-500 font-mono text-lg"
                />
                {revisedDaysCount !== leaveToApprove.days_count && (
                  <p className="text-xs text-blue-700 mt-2 flex items-center">
                    <AlertTriangle className="w-3 h-3 mr-1" />
                    Days revised from {leaveToApprove.days_count} to {revisedDaysCount}
                  </p>
                )}
              </div>

              {/* Approval Remarks */}
              <div>
                <label className="block text-xs font-medium text-slate-700 mb-2 uppercase tracking-widest">
                  Remarks (Optional)
                </label>
                <textarea
                  value={approvalRemarks}
                  onChange={(e) => setApprovalRemarks(e.target.value)}
                  placeholder="Add any notes for this approval..."
                  className="w-full px-4 py-2 border border-slate-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-primary h-20 resize-none"
                />
              </div>

              {/* Action Buttons */}
              <div className="flex justify-end space-x-3 pt-4 border-t border-slate-200">
                <button
                  onClick={() => setLeaveApprovalDialogOpen(false)}
                  className="btn-outline"
                >
                  Cancel
                </button>
                <button
                  onClick={handleApproveLeave}
                  disabled={revisedDaysCount <= 0}
                  className="btn-primary bg-success hover:bg-success/90 flex items-center space-x-2 disabled:bg-slate-300"
                >
                  <CheckCircle className="w-4 h-4" />
                  <span>Approve Leave</span>
                </button>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default LeaveApprovalDialogSection;
